export function getSearchQuery(params: URLSearchParams) {
  // undefined for easy compatibility with e.g. param?: string, since TS is configured
  // for separate null vs undefined checks
  return params.get("q") ?? params.get("search") ?? undefined;
}
